import { HttpInterceptorFn } from '@angular/common/http';

import { AppConfigWindow } from 'app/interfaces';

export const versionInterceptor: HttpInterceptorFn = (req, next) => {
    const version = (window as AppConfigWindow).appConfig?.version;

    return next(req.clone({ setHeaders: { 'Web-Client-Version': version || 'unknown' } }));
};
